import React from 'react';
import s from './Footer.scss';
import question from '../../../assets/images/icons/help-circle-cyan.svg';
import { getUrlState } from '../../../utils';
import { abtest  } from '../../../utils';


export const Footer = ({ apptype, style, uw, abtestData, status}) => {
    return(
        <div className={s.mainFooter} style={style}>
            <div className={uw ? s.uwFooter : s.footer}>
                <div className={s.faqContainer} >
                    <img className={s.questionIcon}  src={question} alt='signo de pregunta'/>
                    <a className={s.faq} href="/faqs" target="_blank">{(getUrlState(window.location.pathname) == 'propuesta') || (getUrlState(window.location.pathname) == 'simulador')? 'Más Preguntas Frecuentes' : 'Preguntas Frecuentes'}
                    </a>
                </div>
                {(apptype && status < 30) &&
                    <div className={s.creditContainer} >
                        <p className={s.changeForm}><a className={s.faq} href="/">{`Solicitar otro tipo de ${abtest(abtestData)}`}</a></p>
                    </div>
                }
            </div>
        </div>
    );
}

export default Footer;
